import { environment } from "models/Environment";
import { createContext } from "react";

import { MsalUser } from "./User";

export interface IAuthenticationContext {
  currentUser: MsalUser;
  acquireTokenSilent: (scopes?: string[]) => Promise<string>;
  logout: () => void;
}

export const AuthenticationContext = createContext<IAuthenticationContext | undefined>(undefined);

export const defaultScopes = [`${environment.applicationIdUrl}/user_impersonation`];
